module.exports = "<p>\n  deputation-rec-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/deputaion/deputaion-rec/deputation-rec-form/deputation-rec-form.component.html
// module id = ./src/app/hrms/deputaion/deputaion-rec/deputation-rec-form/deputation-rec-form.component.html
// module chunks = main